import { useEffect, useRef } from 'react'
// eslint-disable-next-line import-x/no-named-as-default
import ReCAPTCHA from 'react-google-recaptcha'
import styles from './Captcha.module.css'

const Captcha = ({ siteKey, instance, onRecaptchaRendered, onSubmit }) => {
  const isFirstRenderRef = useRef(true)

  useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false
      return
    }
    if (instance && instance.getValue()) {
      instance.reset()
    }
  })

  return (
    <ReCAPTCHA
      className={styles['captcha-field']}
      sitekey={siteKey}
      size='invisible'
      onChange={onSubmit}
      ref={onRecaptchaRendered}
    />
  )
}

export default Captcha
